import check from "../img/check.svg"
import plan from "../img/Plan.png"

export const Plan = () =>{

 
    return(
         <section className="plan container1 center">
            <h1>Choose Your Plan</h1>
            
            <h2>Let's choose the package that is best for you and<br/> explore it happily and cheerfully.</h2>
            <div id="pricing" className="flex">
            <div className="plan-card" >
                <img  src={ plan }  />
                <h3>Free Plan</h3>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Unlimited Bandwitch</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Encrypted Connection</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>No Traffic Logs</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Works on All Devices</p>
                </div>
                <h3 className="plan-down" >Free</h3>
                <div className="main-button">Select</div>
            </div>

            <div className="plan-card" >
                <img  src={ plan }  />
                <h3>Standard Plan</h3>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Unlimited Bandwitch</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Encrypted Connection</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Yes Traffic Logs</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Works on All Devices</p>
                </div>

                <div className="about-flex" >
                  <img src={ check } />
                  <p>Connect Anyware</p>
                </div>
                
                <h3 className="plan-down" >$9 / mo</h3>
                <div className="main-button">Select</div>
            </div>

            <div className="plan-card" >
                <img  src={ plan }  />
                <h3>Premium Plan</h3>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Unlimited Bandwitch</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Encrypted Connection</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>No Traffic Logs</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Works on All Devices</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Connect Anyware</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Get New Features</p>
                </div>
                <h3 className="plan-down" >$12 / mo</h3>
                <div className="main-button">Select</div>
            </div>
            <div className="plan-card" >
                <img  src={ plan }  />
                <h3>Premium+ Plan</h3>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Unlimited Bandwitch</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Encrypted Connection</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>No Traffic Logs</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Works on All Devices</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Connect Anyware</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Get New Features</p>
                </div>
                <div className="about-flex" >
                  <img src={ check } />
                  <p>Encrypted Connection</p>
                </div>
                <h3 className="plan-down" >$12 / mo</h3>
                <div className="main-button">Select</div>
            </div>
            
            
            
            

  

   
            </div>
            
        </section>
    )
   
}